// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2JC2Y","form":"form__1ZKLu","textarea":"textarea__3l8Qm","modal":"modal__3kxTU"};